// extracted by mini-css-extract-plugin
export default {"title":"DayRow_title__6OK8G"};